import { render } from "./MusicPlayer.vue?vue&type=template&id=01c705f1"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=01c705f1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__